import { Flex, Grid, InfoIcon } from '@fareye/ui'
import { formatMs } from '@fareye/utils'
import React from 'react'
import {
  DimensionButton,
  GraphHeading,
  GroupedButton,
  InfoDuration
} from '../../../style/styled'
import { IGraphHeaderConfig } from '../../../utility/types'
import { useTranslation, constants } from '@fareye/common'

const GraphHeader = ({
  config: {
    dataConfig: { graphDataMapping },
    graphConfig
  },
  selectedDimension,
  setSelectedDimension,
  globalFilter
}: IGraphHeaderConfig) => {
  const { t } = useTranslation()
  const activeButton = (ele: any) =>
    ele.dimension[graphDataMapping.dimension.value] === selectedDimension
  const getDays = (globalFilter: any) => {
    let timeDiff: any
    try {
      if (globalFilter) {
        const {
          dateRange: { startDate, endDate }
        } = globalFilter
        timeDiff = new Date(endDate).getTime() - new Date(startDate).getTime()
        return timeDiff ? formatMs(timeDiff) : `1 ${t(constants['Day'])}`
      }
    } catch (ex:any) {
      return `1 ${t(constants['Day'])}`
    }
  }
  const {
    chartTitle,
    chartDescription,
    hideDateDiff = false,
    dimensions
  } = graphConfig

  return (
    <Flex className="mt122" column>
      <Flex alignItemsCenter>
        <GraphHeading variant="h6" title={chartTitle}>
          {t(chartTitle)}
        </GraphHeading>
        {chartDescription && (
          <InfoIcon
            style={{ marginLeft: 5, marginRight: 5 }}
            title={t(chartDescription)}
          />
        )}
        {!hideDateDiff && (
          <InfoDuration>
            {t(constants['Last'])} {getDays(globalFilter)}
          </InfoDuration>
        )}
      </Flex>
      {/* {dimensions.length > 1 ? (
        <Flex justifyContentFlexEnd>
          <GroupedButton>
            {dimensions.map((ele, index) => (
              <DimensionButton
                variant={`${activeButton(ele) ? 'h6' : ''}`}
                key={`dimensionButton${index}`}
                onClick={() => {
                  setSelectedDimension(
                    ele.dimension[graphDataMapping.dimension.value]
                  )
                }}
              >
                {ele.dimension[graphDataMapping.dimension.label]}
              </DimensionButton>
            ))}
          </GroupedButton>
        </Flex>
      ) : null} */}
      <Flex justifyContentFlexEnd>
        <GroupedButton>
          {dimensions.length > 1 ? (
            dimensions.map((ele, index) => (
              <DimensionButton
                variant={`${activeButton(ele) ? 'h6' : ''}`}
                key={`dimensionButton${index}`}
                onClick={() => {
                  setSelectedDimension(
                    ele.dimension[graphDataMapping.dimension.value]
                  )
                }}
              >
                {t(ele.dimension[graphDataMapping.dimension.label])}
              </DimensionButton>
            ))
          ) : (
            <div style={{ padding: '11px' }}></div>
          )}
        </GroupedButton>
      </Flex>
    </Flex>
  )
}
export default GraphHeader
